// extracted by mini-css-extract-plugin
export default {"wrapper":"Form_wrapper__UZrQd","form-group":"Form_form-group__6kn4q"};